import { invalidateGuidedFlow } from './guidedFlow/queries';

/**
 * Invalidate every React Query cache that depends on cycle income, expenses,
 * savings rate, budget spent, pots, or goals progress.
 */
export async function invalidateFinancialData(qc, { refetchType = 'active' } = {}) {
  const opts = { exact: false, refetchType };
  await Promise.all([
    qc.invalidateQueries({ queryKey: ['expenses'], ...opts }),
    qc.invalidateQueries({ queryKey: ['income'], ...opts }),
    qc.invalidateQueries({ queryKey: ['budgets'], ...opts }),
    qc.invalidateQueries({ queryKey: ['pots'], ...opts }),
    qc.invalidateQueries({ queryKey: ['goals'], ...opts }),
  ]);
  invalidateGuidedFlow(qc);
}
